/* eslint-disable @typescript-eslint/no-explicit-any */

export const uaAddScript = ({ advertisingEnabled }: { advertisingEnabled: boolean }) => {
  if (window.ga) {
    return;
  }

  (function (i: any, s: any, o: any, g: any, r: any, a: any, m: any) {
    i.GoogleAnalyticsObject = r;
    (i[r] =
      i[r] ||
      function () {
        // eslint-disable-next-line prefer-rest-params
        (i[r].q = i[r].q || []).push(arguments);
      }),
      (i[r].l = (1 as any) * (new Date() as any));
    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga', {}, {});

  uaSetAdvertisingFeatures(advertisingEnabled);
};

export const uaSetupTracking = (gaPropertyId: any, tock2usGaPropertyId: any) => {
  window.ga('create', gaPropertyId, 'auto');
  window.ga('create', tock2usGaPropertyId, 'auto', 'tock2us');
  window.ga('send', 'pageview');
};

export const uaSetAdvertisingFeatures = (advertisingEnabled: boolean) => {
  if (window.ga) {
    if (advertisingEnabled) {
      window.ga('set', 'allowAdFeatures', true);
    } else {
      window.ga('set', 'allowAdFeatures', false);
    }
  }
};
